import React, { useEffect, useState, useContext } from 'react';
import Carddass from '../components/Card/Carddass';
import { Button, Alert, Jumbotron, Row, Col, Spinner } from 'reactstrap';
import { useFirebase, useFirestore } from 'react-redux-firebase';
import queryString from 'query-string';
import Loading from '../components/Loading';
import { Redirect, Link } from 'react-router-dom';
import { CarddassContext, UserContext } from '../contexts';
import logo from '../assets/img/brand/jccw-logo.svg';

export default function Trade(props) {
    const [card, setCard] = useState();
    const [sender, setSender] = useState();
    const [expired, setExpired] = useState(false);
    const [loadingTrade, setLoadingTrade] = useState(false);
    const [complete, setComplete] = useState(false);
    const user = useContext(UserContext);
    const firebase = useFirebase();
    const firestore = useFirestore();
    const params = queryString.parse(window.location.search);
    const carddass = useContext(CarddassContext);

    useEffect(() => {
        const getData = async() => {
            var tradeDoc = await firestore.get('trades/' + params.id);
            if(tradeDoc.exists) {
                var tradeData = tradeDoc.data();
                var senderDoc = await firestore.collection('users').doc(tradeData.senderId).get();
                var cardData = carddass.find(c => c.id === tradeData.cardId);
                var senderData = senderDoc.data();
                setCard(cardData);
                setSender(senderData);
            } else {
                setExpired(true);
            }
        }
        getData();
    }, [firestore, carddass, params.id]);

    async function trade(){
        setLoadingTrade(true);
        var tradeCarddass = firebase.app().functions('asia-northeast1').httpsCallable('tradeCarddass');
        var ret = await tradeCarddass({recipientId : user.id, tradeId : params.id});
        if(ret.data.success) {
            setComplete(true);
        }
        setLoadingTrade(false);
    }    

    async function cancel(){
        setComplete(true);
    }

    if(complete) return (<Redirect to="/cards" />);

    if(expired) return (
        <Jumbotron>
            <Alert color="danger">取引IDが無効です。すでに取引が完了している場合があります。</Alert>
            <Link to="/cards">カードリストを見る</Link>
        </Jumbotron>
    );

    if(!card || !sender) return (<Loading />);

    return (
        <div className="trade">
            <Row>
                <Col className="text-center p-2 bg-light">
                    <img src={logo} alt="" className="w-25" style={{maxWidth:"100px"}} />
                </Col>
            </Row>
            <Jumbotron>
                <Row>
                    <Col xs="12" sm="6" md="4">
                        <Carddass card={card} showImage={true} />
                    </Col>
                    <Col xs="12" sm="6" md="8">
                        <Alert color="primary">
                            <p>{sender.familyName}{sender.givenName}さんから、このカードを受け取りますか？</p>
                            <Button color="primary" onClick={async () => trade()} disabled={loadingTrade}>
                            {loadingTrade && <Spinner size="sm" />}
                            {' '}
                                はい
                            </Button>
                            {' '}
                            <Button color="secondary" onClick={async () => cancel()}>いいえ</Button>
                        </Alert>
                    </Col>
                </Row>
            </Jumbotron>
        </div>
    );
}